import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Home = props => (
  <SvgIcon viewBox="0 0 16.344 17.117" {...props}>
    <g id="website-home" transform="translate(-7.857)">
      <path id="Path_2527" data-name="Path 2527" d="M24.2,6.9,16.03,0,7.857,6.9V8.427l1.263,0v8.692h5.012V12.225h3.795v4.892h5.012V8.425l1.264,0Z" />
    </g>
  </SvgIcon>
);

export default Home;
